import { useLocation } from 'react-router-dom';
import { isEnglishPath } from '../utils/i18nRoutes';
import ContactForm from './ContactForm';

export default function FormPanel() {
  const location = useLocation();
  const isEn = isEnglishPath(location.pathname);

  const h3 = isEn
    ? 'We will get back to you within one business day.'
    : 'Wir melden uns innerhalb eines Werktages bei Ihnen.';
  const intro = isEn
    ? 'Briefly describe your request. The initial consultation is free and non-binding.'
    : 'Beschreiben Sie kurz Ihr Anliegen. Das Erstgespräch ist kostenlos und unverbindlich.';

  return (
    <section id="anfrage" className="py-20 px-6 bg-white dark:bg-gray-900">
      <div className="max-w-6xl mx-auto">
        <div className="bg-primary rounded-panel p-8 md:p-12 lg:p-16 grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left: heading */}
          <div className="flex flex-col justify-center">
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4 leading-snug">
              {h3}
            </h3>
            <p className="text-blue-50 leading-relaxed">
              {intro}
            </p>
          </div>

          {/* Right: form */}
          <div>
            <ContactForm variant="dark" />
          </div>
        </div>
      </div>
    </section>
  );
}
